import React, { useEffect, useState, useMemo } from 'react';
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination
} from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import apiClient from '../utils/apiClient';
import { useNavigate } from 'react-router-dom';

// Global Search Filter Component
const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <input
      value={filter || ''}
      onChange={(e) => setFilter(e.target.value)}
      placeholder="Search centers..."
      style={{
        fontSize: '16px',
        width: '80%',
      }}
      className='form-control'
    />
  );
};
const CenterList = () => {
  const [data, setData] = useState([]);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  // Fetch data from the backend
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfo`, {
          headers: {
            'Authorization': `Bearer ${token}`, // Add the JWT token in the header
          },
        });
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchCenters();
  }, []);

  // Handle Edit
  const handleEdit = (center) => {
    navigate('../addCenter', { state: { centerData: center } });
  };

  const handleDelete = async (row) => {
    const centerId = row.id;
    const centerEmail = row.email;

    if (!token) {
      Swal.fire({
        icon: 'error',
        text: 'Unauthorized: Please log in to proceed.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to undo this action!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiClient.delete(`${SERVER_BASE}/deleteCenter/${centerId}`, {
            data: { centerEmail },
            headers: { Authorization: `Bearer ${token}` },
          });

          setData((prevData) => prevData.filter((center) => center.id != centerId));

          Swal.fire({
            icon: 'success',
            title: 'Center deleted!',
            text: 'The center has been successfully deleted.',
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
          });
        } catch (error) {
          console.error('Error deleting center:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: error.response?.data?.message || 'There was an error deleting the center.',
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
          });
        }
      }
    });
  };

  // Define columns
  const columns = useMemo(
    () => [
      { accessor: 'centerCode', Header: 'Center Code' },
      { accessor: 'centerName', Header: 'Center Name' },
      { accessor: 'gstin', Header: 'GSTIN' },
      { accessor: 'contactPerson1', Header: 'Contact Person 1' },
      {
        Header: 'Actions',
        Cell: ({ row }) => (
          <div>
            <button
              onClick={() => handleEdit(row.original)}
              className="btn btn-sm btn-success me-2"
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>
            <button
              onClick={() => handleDelete(row.original)}
              className="btn btn-sm btn-danger"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    setGlobalFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className='formcontainer mt-5'>
      <h4 style={{ textAlign: 'left' }}>Center Details</h4>
      <div className='d-flex justify-content-between'>

<button
className="btn btn-success"
onClick={() => navigate('../addCenter')}
>
 Add Center
</button>      <GlobalFilter filter={state.globalFilter} setFilter={setGlobalFilter} />

      </div>

      <table {...getTableProps()} className="table table-striped table-responsive">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="pagination d-flex justify-content-between align-items-center">
        <button onClick={() => previousPage()} disabled={!canPreviousPage} className='btn btn-secondary'>
          Previous
        </button>
        <span>
          Page <strong>{state.pageIndex + 1}</strong> of {pageOptions.length}
        </span>
        <button onClick={() => nextPage()} disabled={!canNextPage} className='btn btn-secondary'>
          Next
        </button>
      </div>
    </div>
  );
};

export default CenterList;
